<template>
    <toolbar-option type="stacked">
        <template slot="primary">
            <input type="text" :value="url" @input="onInput">
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

const CUSTOM_ATTR_NAME = 'icon-search-url';

export default {
    name: 'icon-search-url',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Search URL',
            url: '',
        };
    },

    methods: {
        onInput(e) {
            this.url = e.target.value;
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.url);
            this.onOptionChange(this.url);
        },

        onSelectedElement() {
            this.url = this.selectedElements[0].getElementData(CUSTOM_ATTR_NAME);
        },
    },
};
</script>
